import { render, staticRenderFns } from "./_image.vue?vue&type=template&id=52a69253&"
import script from "./_image.vue?vue&type=script&lang=js&"
export * from "./_image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports